var map = {
	"./geology-earth.png": "d046",
	"./geology-jupiter.png": "175b",
	"./geology-mars.png": "e070",
	"./geology-mercury.png": "3da1",
	"./geology-neptune.png": "cb80",
	"./geology-saturn.png": "0e9e",
	"./geology-uranus.png": "8bd7",
	"./geology-venus.png": "01a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef43";